'use client';
function identityResolver(value) {
  return value;
}

export { identityResolver };
//# sourceMappingURL=identity-resolver.mjs.map
